/**
 * Адреса вкладки «Тарифы». Живут отдельно от PaywallModal: компонентный файл
 * с не-компонентными экспортами ломает Fast Refresh (react-doctor
 * only-export-components).
 */

/** Вкладка «Тарифы» в настройках текущего воркспейса; параметр читает DashboardPage. */
export const BILLING_SETTINGS_URL = '/dashboard?ws=billing';

/**
 * Тот же адрес, но с явным воркспейсом: paywall мог сработать на карте из другого
 * воркспейса, и оплачивать нужно ЕГО тариф, а не тот, что сейчас активен.
 */
export function billingSettingsUrl(workspaceId?: string | null): string {
  return workspaceId
    ? `${BILLING_SETTINGS_URL}&wsId=${encodeURIComponent(workspaceId)}`
    : BILLING_SETTINGS_URL;
}
